import { useEffect, useState, useRef } from 'react';
import { useDebounce, useUnmount } from 'react-use';

const useSearchBar = (props) => {
  const { value, visible, timeoutMs, onClear, onChange, onSearch } = props;
  const [searchQuery, setSearchQuery] = useState(value);
  const inputRef = useRef(null);

  const [, cancel] = useDebounce(
    () => {
      if (value !== searchQuery) {
        onSearch(searchQuery);
      }
    },
    timeoutMs,
    [searchQuery],
  );

  useUnmount(() => cancel());

  useEffect(() => {
    if (searchQuery !== value) {
      setSearchQuery(value);
    }
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (visible && inputRef.current) {
      inputRef.current.focus();
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 300);
    }
  }, [visible]);

  const handleChange = ({ currentTarget }) => {
    setSearchQuery(currentTarget.value);

    onChange(currentTarget.value);
  };

  const handleClear = (event) => {
    setSearchQuery('');
    inputRef.current.focus();

    onClear(event, '', 'clear');
  };

  const handleSearch = (event) => {
    event.preventDefault();

    onSearch(searchQuery);
  };

  return {
    inputRef,
    value: searchQuery,
    setSearchQuery,
    onChange: handleChange,
    onClear: handleClear,
    onSearch: handleSearch,
  };
};

export default useSearchBar;
